<template>
    <div class="pnews news-ct news-cur pl30 pr20">
        <div v-for="(item, idx) in newsList" :key="item.id" @click="_getDetail(item, idx)" class="news-s dblock lh20  mb20 prelative before pl15 pr10 fs0 cpointer" :class="item.category_id != 117 ? 't-hidden' : ''" :title="item.title">
            <template v-if="item.category_id != 117">
                <span class="sdate tc9 fr fs16 tright">{{ item.open_time }}</span>
                <span class="title dinline-block fs16 t-hidden">{{ item.title }}</span>
            </template>
            <template v-else>
                <div class="ceo_box fs16">
                    <div class="ceo_box_left">
                        <img class="ceo_box_left_img" :src="item.picture[0]">
                        <img class="ceo_box_left_img_2" :src="require('@/assets/images/puse.png')">
                    </div>
                    <div class="ceo_box_right">
                        <div class="cbl_title two_dot_hide">{{ item.title }}</div>
                        <div class="cbl_time">发布时间：{{ item.open_time }}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    props: ['newsList', 'page', 'pageSize', 'showPage', 'link'],
    created() {

        // console.log('1111111111111:',this.newsList)
    },
    methods: {
        _getDetail(item, num) {
            let baseDir = this.$params.baseDir
            let path = baseDir + `news/detail/${item.id}`
            let typeId = item.category_id
            if (this.link)
                path = baseDir + this.link + '/' + item.id
            else if (this.$params.newsType[typeId]['root'] == 2)//招生继续教育
                path = baseDir + 'edu/detail/' + item.id
            else if (this.$params.newsType[typeId]['root'] == 3)//非学历
                path = baseDir + 'train/detail/' + item.id
            let pushV = {
                path: path,
            }
            if (this.showPage) {
                pushV.query = {
                    typeId: item.category_id,
                    page: this.page,
                    pageSize: this.pageSize,
                    num: num + 1
                }
            }
            this.$router.push({
                path: path,
                query: {
                    typeId: item.category_id,
                    page: this.page,
                    pageSize: this.pageSize,
                    num: num + 1

                }

            })
        }
    }
}
</script>
<style scope>
.pnews .news-s:hover .sdate {
    font-weight: normal;
    color: var(--mcolor);
}
.ceo_box{
    display: flex;
    flex-direction: row;
    height:160px;
    margin-bottom:20px;
}
.ceo_box_left{
    width:30%;
}
.ceo_box_left_img{
    width:100%;
    border-radius:5px;
}
.ceo_box_right{
    width:69%;
    margin-left:1%;
    display: flex;
    flex-direction: column;
    padding:10px;
}
.cbl_title{
    height:60px;
    line-height:30px;
    overflow: hidden;
    font-size:24px;
    color:#333333;
}
.cbl_time{
    height:20px;
    line-height:20px;
    font-size:15px;
    margin-top:30px;
    color:#999999;
}
.two_dot_hide {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -moz-box;
    -moz-line-clamp: 1;
    -moz-box-orient: vertical;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.ceo_box_left_img_2{
    width:29px;
    height:29px;
    margin-left:calc(-14% - 14.5px);
    margin-top:55px;
    position:absolute;
}
</style>